import { apiCallback } from 'api';

const definition = {
  service: 'address-finder',
  endpoint: 'address-suggestions',
  query: { text: '${text}', resultSet: '${resultSet}' },
  verbs: ['get'],
  defaultVersion: 1,
  headers: { 'Client-Identifier': 'waitrose-digital-web' },
};

export default {
  get: apiCallback(definition, 'get'),
};
